/** Disable HTTP caching for API requests (browser + intermediate caches). */
export const AXIOS_NO_CACHE_HEADERS = {
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  Pragma: 'no-cache',
  Expires: '0',
} as const;